import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { AcompanhamentoBatchDetalheComponent } from "./acompanhamento-batch-detalhe/acompanhamento-batch-detalhe.component";
import { AcompanhamentoBatchPesquisaComponent } from "./acompanhamento-batch-pesquisa/acompanhamento-batch-pesquisa.component";

const routes: Routes = [
    {
        path: 'acompanhamento-batch/pesquisa',
        component: AcompanhamentoBatchPesquisaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        data: { canReuse: false },
    },
    {
        path: 'acompanhamento-batch',
        component: AcompanhamentoBatchDetalheComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        data: { canReuse: false },
    },
    {
      path: 'acompanhamento-batch/:id',
      component: AcompanhamentoBatchDetalheComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
      data: { canReuse: false },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class AcompanhamentoBatchRoutingModule {}


